module.exports = __webpack_public_path__ + "img/spirit_1920.50b15350.png";